import {formatMonetaryToBr} from '../../../../../utils/formatMonetaryToBr'

const formatMoney = (value: number | undefined | null): string => formatMonetaryToBr(value ?? 0)

// O backend envia participações como fração (0.1234 = 12,34%).
const formatPercent = (value: number | undefined | null): string =>
  Number(value ?? 0).toLocaleString('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

const formatNumber = (value: number | undefined | null, fractionDigits = 0): string =>
  Number(value ?? 0).toLocaleString('pt-BR', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })

export {formatMoney, formatPercent, formatNumber}
